export default "__VITE_ASSET__LbLBGy5$__"